import type { FinanceData, SuggestedAction } from '../types'
import { deterministicInsights, monthSummary, parsePersianFinanceText } from './finance'

const apiMode = import.meta.env.VITE_API_MODE === 'cloudflare'

async function askWorker(payload: Record<string, unknown>) {
  const response = await fetch('/api/ai', {
    method: 'POST', credentials: 'include', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload),
  })
  const result = await response.json().catch(() => ({})) as { answer?: string; action?: SuggestedAction; error?: string }
  if (!response.ok) throw new Error(result.error || 'AI در دسترس نیست.')
  return result
}

export async function getAiAdvice(data: FinanceData, monthKey: string, question: string) {
  const summary = monthSummary(data, monthKey)
  const local = deterministicInsights(data, monthKey)
  if (!apiMode) return `تحلیل امن آفلاین:\n${local.warnings.map((item) => `• ${item}`).join('\n')}`
  try {
    const result = await askWorker({
      mode: 'advice', monthKey, summary, burdenPercent: local.burden, question,
      activeLoans: data.loans.filter((x) => x.status === 'Active').map((x) => ({ title: x.title, monthly: x.monthlyInstallment, end: x.endDateJalali })),
      debts: data.debts.filter((x) => x.status === 'Active').map((x) => ({ title: x.title, remaining: x.amount - x.paidAmount, due: x.dueDateJalali })),
      futureExpenses: data.futureExpenses.filter((x) => x.status === 'Pending').map((x) => ({ title: x.title, amount: x.amount, due: x.dueDateJalali })),
    })
    return result.answer || local.warnings.join('\n')
  } catch {
    return `تحلیل امن آفلاین:\n${local.warnings.map((item) => `• ${item}`).join('\n')}\n\nپاسخ هوشمند موقتاً در دسترس نیست.`
  }
}

export async function parseWithAi(text: string): Promise<SuggestedAction | null> {
  const local = parsePersianFinanceText(text)
  if (local || !apiMode) return local
  try {
    const result = await askWorker({ mode: 'parse', text })
    return result.action?.amount ? result.action : null
  } catch { return null }
}
